import Link from "next/link";
import { cx } from "@nju/css";
import {
  IMobileFlow,
  IOfferModeWithFSecure,
} from "@nju/data-access-portal-offers";
import { Icon } from "@nju/icons";
import { portalRoutes } from "@nju/routes";
import { Loader } from "@nju/ui";
import { getBadgeState } from "@nju/utils";

interface IButtonProps {
  isActive: boolean;
  isCompleted: boolean;
  label: string;
  mode: IOfferModeWithFSecure;
  badge: string | undefined;
  isMissing: boolean;
  testId?: string;
  userId: string | undefined;
  flow: IMobileFlow | undefined;
  onClick: () => void;
  allowRedirect?: boolean;
  isLoading?: boolean;
}

export function Button({
  isLoading,
  isActive,
  isCompleted,
  label,
  mode,
  badge,
  isMissing,
  testId,
  userId,
  flow,
  onClick,
  allowRedirect = true,
}: IButtonProps) {
  const state = getBadgeState(isActive, isCompleted);

  return (
    <Link
      className={cx(
        "flex items-center gap-2 relative px-3 py-[8px] rounded-badge from-tablet:px-4 from-tablet:py-2",
        {
          "bg-brightCerulean border-solid border-brightCerulean border-2 text-white font-bold":
            state === "active",
          "border-none": state === "completed_inactive",
          "border-brightCerulean border-dashed border-[2px]":
            state === "in_progress_inactive",
        },
      )}
      data-cy={testId}
      href={portalRoutes.mojeKonto.index.get({
        mode,
        ...(userId && { userId }),
        ...(flow && { flow }),
      })}
      onClick={(e) => {
        if (!allowRedirect) {
          e.preventDefault();
        }
        onClick?.();
      }}
      passHref={true}
    >
      {isMissing && !isLoading && (
        <Icon name="plus-circle" tone={isActive ? "secondary" : "accent"} />
      )}
      {isMissing && isLoading && <Loader className="h-[16px] w-[16px]" />}
      {label}
      {badge && (
        <span className="absolute top-0 right-3 bg-ripeLemon rounded-badge text-daintree font-bold text-size-12 px-2 py-0 translate-y-[-50%]">
          {badge}
        </span>
      )}
    </Link>
  );
}
